/*eslint-disable react/no-unknown-property */
/*eslint-disable no-duplicate-imports */
import { useEffect, useState } from 'react';
import { Modal, Row, Col, Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import { useTranslation } from 'react-i18next';
import { arrayBufferToString } from 'src/Member/utils/common';
import { HttpSuccessCodes } from '../../../../../errorhandling/HttpErrorCodes';
import { DownloadDocumentSVG } from '../../../../../img/GlobalSVG';
import CustomClientError from '../../../../../errorhandling/CustomClientError';
import ToastMessage from '../../../../../components/common/ToastMessage/index';

const DownloadDocumentModal = (props) => {
  const {
    activeCoverageType,
    MasterID,
    isVisible,
    onHide,
    customClasses,
    showApply,
    showApplyLabel,
  } = props;
  const [isNotFound, setIsNotFound] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [planDocuments, setplanDocuments] = useState([]);
  const [allDocuments, setallDocuments] = useState(false);

  const { t } = useTranslation();

  const handleHide = () => {
    toast.dismiss();
    onHide();
  };

  useEffect(() => {
    setIsAPIFailed(false);
    setIsNotFound(false);
    setallDocuments(false);
    const getPlanDocuments = async () => {
      let paramString = '';
      if (MasterID) {
        paramString += `MasterID/${MasterID}`;
      }
      if (activeCoverageType) {
        paramString += `/ProductType/${activeCoverageType}`;
      }
      return await axiosInstance.get(
        APIEndpoints.getPlanDocuments() + paramString,
      );
    };
    if (MasterID) {
      (async () => {
        try {
          const documentsList = await getPlanDocuments();
          const data = documentsList.data.Response?.planDocumentDTO || [];
          if (data && data.length) {
            setplanDocuments(data);
            setIsAPIFailed(false);
            setIsNotFound(false);
          } else {
            setIsAPIFailed(true);
            setIsNotFound(true);
          }
        } catch (err) {
          if (err.toString().includes('404')) {
            setIsNotFound(true);
          }
          setIsAPIFailed(true);
          console.log(err);
        }
      })();
    }
  }, [MasterID, allDocuments]);

  const downloadFile = async (masterID, fileName) => {
    try {
      const parameter = `MasterID/${masterID}/FileName/${btoa(fileName)}`;
      const documentData = await axiosInstance.get(
        APIEndpoints.getPlanCoverageDocument() + parameter,
        { responseType: 'arraybuffer' },
      );
      if (documentData.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        const link = document.createElement('a');
        const actualData = arrayBufferToString(documentData.data);
        link.setAttribute('href', 'data:application/pdf;base64, ' + actualData);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsAPIFailed(false);
        setIsNotFound(false);
        toast.success(
          <ToastMessage
            type="success"
            subTitle={`${fileName} downloaded successfully`}
          />,
        );
      }
      setIsAPIFailed(false);
      setIsNotFound(false);
    } catch (err) {
      setallDocuments(true);
      console.log(err);
      toast.error(
        <ToastMessage
          type="error"
          subTitle={t('modals.downloadplan_modal.error_msg')}
          style={{ zIndex: '99999' }}
        />,
      );
    }
  };

  return (
    <>
      <Modal
        show={isVisible}
        onHide={handleHide}
        className={`Right-Model member generic-model ${customClasses}`}
      >
        <Modal.Header closeButton className="plandocument-header">
          <Container className="px-0">
            <Row className="align-items-center p-0 m-0">
              <Col className="px-0">
                <Modal.Title>
                  {t('modals.downloadplan_modal.module')}
                </Modal.Title>
              </Col>
            </Row>
          </Container>
        </Modal.Header>
        {isAPIFailed ? (
          <Container className="px-0">
            {isNotFound ? (
              <CustomClientError ErrorHeading="No Plan Documents found!" />
            ) : (
              <CustomClientError
                ErrorHeading="Something went wrong with request!"
                ErrorMessage="Please try again."
              />
            )}
          </Container>
        ) : (
          <Modal.Body>
            {planDocuments.length > 0 ? (
              <Container className="px-0 custom-scroller modal-content-container">
                {planDocuments.map((plan) => (
                  <>
                    <Row className="document-item">
                      <Col xs={2} className="pt-4">
                        <DownloadDocumentSVG.PdfSVG />
                      </Col>
                      <Col xs={6} className="document-name">
                        <label className="docu-name">{plan.description}</label>
                        <div className="effcandtermDate">
                          {'' || null !== plan.effDate ? (
                            <span className="document-plan-content">
                              {`Effective Date: ${plan.effDate}`}
                            </span>
                          ) : (
                            ''
                          )}

                          {'' || null !== plan.termDate ? (
                            <span className="document-plan-content">
                              {` | Term Date: ${plan.termDate}`}
                            </span>
                          ) : (
                            ''
                          )}
                        </div>

                        {'' || null !== plan.notes ? (
                          <div>
                            <span className="document-plan-notes">
                              {plan.notes}
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                      </Col>
                      <Col xs={4} className="download-plan-document pt-4">
                        <button
                          className="download-document-button"
                          onClick={(e) => {
                            downloadFile(plan.masterID, plan.fileName, e);
                          }}
                        >
                          <DownloadDocumentSVG.DownloadIconSVG className="svg-icon-download" />
                          <span className="download-plan-document-text">
                            {t('download')}
                          </span>
                        </button>
                      </Col>
                    </Row>
                  </>
                ))}
              </Container>
            ) : null}
          </Modal.Body>
        )}
        <Modal.Footer>
          <div className="model-footer-btn txt-right p-0 m-0 border-0">
            {showApply && (
              <button
                onClick={handleHide}
                variant="primary"
                className="close-btn"
              >
                {showApplyLabel}
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>

      {/*<div className="toastify">
        <ToastContainer
          draggable
          pauseOnHover
          closeOnClick
          rtl={ false }
          pauseOnFocusLoss
          autoClose={ 5000 }
          position="top-center"
          newestOnTop={ false }
          hideProgressBar={ false }
          className="toastcontainer"
        />
      </div> */}
    </>
  );
};

export default DownloadDocumentModal;
